import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconMoreVeritcal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M8 10.667c-.733 0-1.333.6-1.333 1.333s.6 1.334 1.334 1.334c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333zm0-1.333c.734 0 1.334-.6 1.334-1.334 0-.733-.6-1.333-1.333-1.333-.734 0-1.334.6-1.334 1.333s.6 1.334 1.334 1.334zm0-4c.734 0 1.334-.6 1.334-1.334 0-.733-.6-1.333-1.333-1.333-.734 0-1.334.6-1.334 1.333 0 .734.6 1.333 1.334 1.333z"
	})
});
export default SvgIconMoreVeritcal;
